export class RootState {
  version = "0.0.1";
  loading = true;
}
